<template>
  <div class="stayAhead-body">
    <div class="title">
      Stay Ahead of EU Sustainability <span>Regulations</span> with Wecobi
    </div>
    <div class="text-wrapper">
      <div class="text" v-if="!isSecondTextVisible">
        Starting in <span>2024</span>, the European Union will enforce strict
        sustainability regulations that prohibit the destruction of unsold
        products, commonly known as deadstock. These groundbreaking measures are
        designed to minimize waste and promote a circular economy, compelling
        brands to rethink how they manage excess inventory. <br /><br />Wecobi
        is uniquely positioned to help brands not only comply with these new
        regulations but also turn potential challenges into opportunities. Our
        free pre-order, co-buying platform is designed to incentivize sharing
        and reward loyal customers, allowing you to offload excess inventory at
        discounted rates—all while preserving your brand's value and control.
      </div>
      <div class="second-text" v-if="isSecondTextVisible">
        By encouraging customer participation through waiting and sharing,
        Wecobi fosters a deeper emotional connection between consumers and your
        products. This increased engagement translates into extended product
        lifetimes and higher usage rates, ensuring that your products remain
        valued and in circulation longer. <br /><br />
        Traditional discounting methods often diminish brand loyalty and value
        perception. In contrast, Wecobi's approach enhances exclusivity and
        engagement, driving brand affinity and advocacy. As customers feel more
        connected to your brand, they are less likely to dispose of products
        prematurely, which aligns perfectly with the EU's sustainability goals.
      </div>
      <div class="arrows-wrapper">
        <img
          class="left-arrow"
          :class="{ active: isSecondTextVisible }"
          @click="showFirstText"
          src="../../../assets/sustainability/stayaheadleft.svg"
          alt="left"
        />
        <img
          class="right-arrow"
          :class="{ inactive: isSecondTextVisible }"
          @click="showSecondText"
          src="../../../assets/sustainability/stayaheadright.svg"
          alt="right"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StayAhead",
  data() {
    return {
      isSecondTextVisible: false,
    };
  },
  methods: {
    showSecondText() {
      this.isSecondTextVisible = true;
    },
    showFirstText() {
      this.isSecondTextVisible = false;
    },
  },
};
</script>

<style scoped>
.stayAhead-body {
  width: 100%;
  min-height: 516px;
  background-color: #f7f7fa;
  border-radius: 20px;
  padding: 90px 80px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 50px;
}

.title {
  width: 100%;
  font-size: 30px;
  font-weight: 600;
  line-height: 1.2;
  max-width: 621px;
}

span {
  color: #ff6d0a;
  font-weight: 600;
}

.text-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.text,
.second-text {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  max-width: 1124px;
  opacity: 1;
  transition: opacity 0.3s ease-in-out;
}

.arrows-wrapper {
  display: flex;
  justify-content: space-between;
  height: 35px;
  gap: 40px;
}
.left-arrow {
  opacity: 0.2;
}
.right-arrow {
  opacity: 1;
}
.left-arrow,
.right-arrow {
  cursor: pointer;
  transition: opacity 0.3s ease-in-out;
}
.left-arrow.active,
.right-arrow.active {
  opacity: 1;
}

.right-arrow.inactive {
  opacity: 0.2;
}

@media (max-width: 1280px) {
  .text,
  .second-text {
    max-width: 676px;
  }
}
@media (max-width: 1024px) {
  .text,
  .second-text {
    max-width: 520px;
    font-size: 14px;
  }
}
@media (max-width: 744px) {
  .stayAhead-body {
    min-height: 508px;
    padding: 60px 50px;
    gap: 40px;
  }

  .text,
  .second-text {
    max-width: 505px;
    font-size: 14px;
  }
}
@media (max-width: 431px) {
  .stayAhead-body {
    min-height: 601px;
  }
  .title {
    font-size: 25px;
    max-width: 455px;
  }
  .text,
  .second-text {
    max-width: 339px;
    font-size: 14px;
  }
}

@media (max-width: 500px) {
  .stayAhead-body {
    min-height: 666px;
    padding: 40px 30px;
  }
  .text-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 50px;
  }
  .arrows-wrapper {
    max-width: 76px;
  }
}
</style>
